import { ItemList } from '../../../../orm/index.js'

class AdminBeneficiaryVettingDemographicList extends ItemList {
  getEntityKey() {
    return 'admin/beneficiary_vetting_demographic'
  }
}

export const adminBeneficiaryVettingDemographicList = new AdminBeneficiaryVettingDemographicList(
  'admin_beneficiary_vetting_demographic__default'
)
